import useFeatureFlag from '@customHooks/useFeatureFlag';
import ScreenNames from '@navigation/navigationConstants';
// import FinansialTab from '@organisms/FinansialTab';
import HomeTab from '@organisms/HomeTab';
import PembayaranTab from '@organisms/PembayaranTab';
import ProfileTab from '@organisms/ProfileTab';
import TransactionsTab from '@organisms/TransactionsTab';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { FEATURE_FLAGS } from '@root/constants';
import { tabIconOptions } from '@theme/theme.tsx';
import AmplitudeHelper from '@utils/analytics';
import { AMPLITUDE_CONSTANTS } from '@utils/analytics/constants';
import React, { lazy } from 'react';
import { useTranslation } from 'react-i18next';
import { getTabBarStyle } from './TabNavigation/styles';

const Tab = createBottomTabNavigator();

export function onHomeTabPress(e: typeof AMPLITUDE_CONSTANTS.NavBar) {
  return () => {
    AmplitudeHelper.logEvent(e.home_menu_clicked.name, {});
  };
}

export function onProfileTabPress(e: typeof AMPLITUDE_CONSTANTS.NavBar) {
  return () => {
    AmplitudeHelper.logEvent(e.others_menu_clicked.name, {});
  };
}

export function onPembayaranTabPress(e: typeof AMPLITUDE_CONSTANTS.NavBar) {
  return () => {
    AmplitudeHelper.logEvent(e.other_product_menu_clicked.name, {});
  };
}

export function onFinansialTabPress(e: typeof AMPLITUDE_CONSTANTS.NavBar) {
  return () => {
    AmplitudeHelper.logEvent(e.financial_menu_clicked.name, {});
  };
}

export function onTransactionTabPress(e: typeof AMPLITUDE_CONSTANTS.NavBar) {
  return () => {
    AmplitudeHelper.logEvent(e.transaction_menu_clicked.name, {});
  };
}

const TabNavigator: React.FC = () => {
  const { t } = useTranslation('common');

  const [isFeatureAvailable] = useFeatureFlag({
    featureName: [FEATURE_FLAGS.BP_TAB],
  });

  const e = AMPLITUDE_CONSTANTS.NavBar;

  return (
    <Tab.Navigator
      screenOptions={{
        tabBarStyle: getTabBarStyle(),
      }}>
      <Tab.Screen
        name={ScreenNames.HomeTab}
        title=""
        component={HomeTab}
        listeners={{ tabPress: onHomeTabPress(e) }}
        options={{
          ...tabIconOptions('home', t('common.homeTab')),
          tabBarButtonTestID: 'tabHome',
        }}
      />
      <Tab.Screen
        name={ScreenNames.TransactionsTab}
        component={TransactionsTab}
        listeners={{ tabPress: onTransactionTabPress(e) }}
        options={{
          ...tabIconOptions('transaction', t('common.transactionTab')),
          tabBarButtonTestID: 'tabTransactions',
        }}
      />

      {isFeatureAvailable[FEATURE_FLAGS.BP_TAB]?.show && (
        <Tab.Screen
          name={ScreenNames.PembayaranTab}
          component={PembayaranTab}
          options={{ ...tabIconOptions('billpayment', t('common.bpTab')), tabBarButtonTestID: 'tabBP' }}
          listeners={{ tabPress: onPembayaranTabPress(e) }}
        />
      )}
      <Tab.Screen
        name={ScreenNames.ProfileTab}
        component={ProfileTab}
        options={{ ...tabIconOptions('profile', t('common.profileTab')), tabBarButtonTestID: 'tabProfile' }}
        listeners={{ tabPress: onProfileTabPress(e) }}
      />
    </Tab.Navigator>
  );
};

export default TabNavigator;
